import { memo } from "react";

const ChevronIconRight: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <path
        d="M2.16266 7.83734C2.05422 7.72891 2 7.59745 2 7.44297C2 7.28848 2.05422 7.15703 2.16266 7.0486L5.21124 4L2.16266 0.951401C2.05422 0.842972 2 0.711516 2 0.557031C2 0.402547 2.05422 0.271091 2.16266 0.162662C2.27109 0.054221 2.40255 0 2.55703 0C2.71152 0 2.84297 0.054221 2.9514 0.162662L6.3152 3.52646C6.38526 3.59651 6.43468 3.67039 6.46345 3.74812C6.49224 3.82584 6.50664 3.9098 6.50664 4C6.50664 4.0902 6.49224 4.17416 6.46345 4.25188C6.43468 4.32961 6.38526 4.4035 6.3152 4.47354L2.9514 7.83734C2.84297 7.94578 2.71152 8 2.55703 8C2.40255 8 2.27109 7.94578 2.16266 7.83734Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { ChevronIconRight };
